export const SIDEBAR_WIDTH = 250;
export const TRANSITION_DURATION = 0.2;
